import EditCustomAttributesLightBoxContainer from './EditCustomAttributesContainer';

export default EditCustomAttributesLightBoxContainer;
